export const s3Mapping = [
    { name: 'Lehigh', orgId: 1 },
    { name: 'Bucknell', orgId: 29 },
    { name: 'Alzheimer', orgId: 61 },
    { name: 'Barnard', orgId: 47 },
    { name: 'CHOPS', orgId: 7 },
    { name: 'MMC', orgId: 8 },
    { name: 'Ovrture', orgId: 12 },
    { name: 'Tulane', orgId: 16 },
    { name: 'VCU', orgId: 17 },
    { name: 'UCSF', orgId: 18 },
    { name: 'UVA', orgId: 19 },
    { name: 'Susquehanna', orgId: 25 },
    { name: 'BCHT', orgId: 26 },
    { name: 'TCU', orgId: 27 },
    { name: 'NCSU', orgId: 28 },
    { name: 'Bucknell', orgId: 29 },
    { name: 'PEDDIE', orgId: 31 },
    { name: 'IUHF', orgId: 33 },
    { name: 'DICKINSON', orgId: 34 },
    { name: 'Muhlenberg', orgId: 35 },
    { name: 'CU_Denver', orgId: 36 },
    { name: 'Intermountain', orgId: 37 },
    { name: 'MD+Anderson', orgId: 38 },
    { name: 'BAYLOR', orgId: 39 },
    { name: 'Stanford+University-New', orgId: 40 },
    { name: 'UCDavis', orgId: 41 },
    { name: 'Common+Spirit', orgId: 42 },
    { name: 'UC+Riverside', orgId: 43 },
    { name: 'Marts%26Lundy+', orgId: 44 },
    { name: 'DePaul+University', orgId: 45 },
    { name: 'Harvard+Business+School', orgId: 46 },
    { name: 'Barnard', orgId: 47 },
    { name: 'Indiana+University', orgId: 48 },
    { name: 'University+of+Delaware', orgId: 50 },
    { name: 'Auburn+University', orgId: 51 },
    { name: 'Ovrture+University+POC', orgId: 52 },
    { name: 'Ovrture+Health+POC', orgId: 53 },
    { name: 'oglebay', orgId: 54 },
    { name: 'Amherst+college', orgId: 55 },
    { name: 'MONTANA', orgId: 56 },
    { name: 'WVUF', orgId: 57 },
    { name: 'ST.THOMAS-NEW', orgId: 58 },
    { name: 'SJU', orgId: 59 },
    { name: 'CalTech', orgId: 60 },
    { name: 'Alzheimer', orgId: 61 },
    { name: 'EARTHJUSTICE', orgId: 62 },
    { name: 'CNH', orgId: 63 },
    { name: 'Boston+College', orgId: 64 },
    { name: 'NIU', orgId: 65 },
    { name: 'USF', orgId: 66 },
    { name: 'UNIVERSITY+OF+BRITISH+COLUMBIA', orgId: 67 },
    { name: 'United+State+Navel+Academy', orgId: 68 },
    { name: 'Mass+general+hospital', orgId: 69 },
    { name: 'MPI', orgId: 70 },
    { name: 'Mass+general+hospital', orgId: 70 },
    { name: 'Rice+University', orgId: 72 },
    { name: 'Ball+State+University', orgId: 73 },
    { name: 'Boston+University', orgId: 74 },
    { name: 'University+of+Memphis', orgId: 75 },
    { name: 'The_Branson_School', orgId: 76 },
    { name: 'Campbell+Hall', orgId: 77 },
    { name: 'Ovrture+University+POC', orgId: 78 },
    { name: 'Ovrture+Health+POC', orgId: 79 },
    { name: 'Cincinnati+Children+Hospital', orgId: 80 },
    { name: 'National+Geographic', orgId: 81 },
    { name: 'Colonial+Williamsburg', orgId: 82 },
    { name: 'Lawrenceville+School', orgId: 83 },
    { name: 'OSU', orgId: 84 },
    { name: 'NYU', orgId: 85 },
    { name: 'UVALAW', orgId: 86 },
    { name: 'University+of+Miami', orgId: 87 },
    { name: 'SBU', orgId: 88 },
    { name: 'The+Movement+for+Black+Lives', orgId: 89 },
    { name: 'ChildrensMercy', orgId: 90 },
    { name: 'Seattle+Childrens', orgId: 91 },
];

export const fetchS3Url = (orgId) => {
    let obj = s3Mapping.find((f) => f.orgId === orgId);
    if (orgId && obj?.name) return `${process?.env?.REACT_APP_S3_URL}/${obj?.name}`;
    else return process?.env?.REACT_APP_S3_URL;
    //return `${process?.env?.REACT_APP_S3_URL}/ui/js/Org_${orgId}`;
};

export const fetchS3TenantName = (orgId) => {
    let obj = s3Mapping.find((f) => f.orgId === orgId);
    return obj?.name;
};
